import { AdminUser } from 'src/interfaces/TicketTypes';

// Admin accounts that must never be offered as somewhere to route work: not as a
// ticket Assignee, a checklist-step assignee, or an @mention target. Covers the
// shared system account and staff who do not handle tickets. Matched
// case-insensitively as a substring, because the stored names vary in
// capitalisation.
//
// This list lives here, and only here. It used to be copy-pasted inline at five
// call sites, and the copies had already drifted — the mention picker compared
// names with an exact match against a single entry, so it offered people the
// Assignee dropdown deliberately hid. It lives in utils/ rather than beside the
// ticket components because the Checklist uses it too.
const HIDDEN_ADMIN_NAMES = ['inesco energy master admin', 'paal myhre'];

// True when this admin may be picked as an assignee or @mentioned.
export function isSelectableAdmin(user: Pick<AdminUser, 'name'>): boolean {
  const name = (user.name ?? '').toLowerCase();
  return !HIDDEN_ADMIN_NAMES.some((hidden) => name.includes(hidden));
}
